import { useAuth } from "../auth/useAuth";

export const useImpersonationForId = () => {
  const auth = useAuth();

  return auth.currentUser?.impersonationForId ?? undefined;
};
